import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    "model-value": _ctx.modelValue,
    items: _ctx.items,
    label: _ctx.label,
    variant: _ctx.variant,
    multiple: _ctx.multiple,
    placeholder: _ctx.placeholder,
    density: "compact",
    "hide-details": "",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    selection: _withCtx(({item}) => [
      _createVNode(_component_ontos_colored_value, {
        option: item,
        form: "chip",
        class: _normalizeClass({'mr-1': _ctx.multiple})
      }, null, 8, ["option", "class"])
    ]),
    item: _withCtx(({item, props}) => [
      _createVNode(_component_v_list_item, _mergeProps(props, { title: undefined }), {
        default: _withCtx(() => [
          _createVNode(_component_ontos_colored_value, {
            option: item,
            form: "chip"
          }, null, 8, ["option"])
        ]),
        _: 2
      }, 1040)
    ]),
    _: 1
  }, 8, ["model-value", "items", "label", "variant", "multiple", "placeholder"]))
}